export default "__VITE_ASSET__215b3706__"